module.exports = __webpack_public_path__ + "static/media/piotr.63dc57cf.jpg";